import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { module } from "../../equipment-registration.module";
import { EquipmentRegistrationPage } from '../equipment-registration/equipment-registration.page';
import { MawopPage } from '../mawop/mawop.page';


@Component({
  selector: 'app-equipment-registration',
  templateUrl: './index.page.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    ...module,
    EquipmentRegistrationPage,
    MawopPage
  ],
  styleUrls: ['./index.page.scss']
})
export class IndexPage {
  constructor(public router: Router){ }

  toggleMawop(routes: any){
    this.router.navigate([`/data-management/eReg/${routes}`]);
  }
}
